import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, TextField, Card, CardContent } from "@material-ui/core";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { emptyString } from "constants/defaultValues";
import SectionTitle from "features/common/components/SectionTitle";

function PersonalDataCard({ userProfileLens }) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <SectionTitle title={t("ProfilePage.PersonalData")} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_firstName"}
              label={t("ProfilePage.FirstName")}
              value={(userProfileLens.firstName |> get) || emptyString}
              onChange={userProfileLens.firstName |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_lastName"}
              label={t("ProfilePage.LastName")}
              value={(userProfileLens.lastName |> get) || emptyString}
              onChange={userProfileLens.lastName |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_positionName"}
              label={t("ProfilePage.Position")}
              value={(userProfileLens.positionName |> get) || emptyString}
              onChange={userProfileLens.positionName |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_phone"}
              label={t("ProfilePage.Phone")}
              value={(userProfileLens.phone |> get) || emptyString}
              onChange={userProfileLens.phone |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_mobilePhone"}
              label={t("ProfilePage.MobilePhone")}
              value={(userProfileLens.mobilePhone |> get) || emptyString}
              onChange={userProfileLens.mobilePhone |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                id={"user_address1"}
                label={t("ProfilePage.Street")}
                value={(userProfileLens.address1 |> get) || emptyString}
                onChange={userProfileLens.address1 |> set |> onTextBoxChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id={"user_address2"}
                label={t("ProfilePage.Street2")}
                value={(userProfileLens.address2 |> get) || emptyString}
                onChange={userProfileLens.address2 |> set |> onTextBoxChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_cityName"}
              label={t("ProfilePage.City")}
              value={(userProfileLens.cityName |> get) || emptyString}
              onChange={userProfileLens.cityName |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_zipCode"}
              label={t("ProfilePage.ZIP")}
              value={(userProfileLens.zipCode |> get) || emptyString}
              onChange={userProfileLens.zipCode |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id={"user_stateName"}
              label={t("ProfilePage.State")}
              value={(userProfileLens.stateName |> get) || emptyString}
              onChange={userProfileLens.stateName |> set |> onTextBoxChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

PersonalDataCard.propTypes = {
  userProfileLens: PropTypes.object.isRequired,
};

export default PersonalDataCard;
